export function normalizeUserRole(raw) {
  const s = String(raw ?? '').trim().toLowerCase()
  if (s === 'underwriter') return 'underwriter'
  return 'broker'
}

/** Uses non-empty `value`; otherwise `default_value` (API often sends value "" with default "broker"). */
export function pickUserTypeRawFromSettingsRow(row) {
  if (!row) return undefined
  try {
    const v = row.value
    if (v != null && String(v).trim() !== '') return v
    const d = row.default_value
    if (d != null && String(d).trim() !== '') return d
    return undefined
  } catch {
    return undefined
  }
}
